import React from 'react';
import './Sentence.css';
import './filtersPage.css';
import prediction from '../assets/filterIcons/prediction.png';
import mcOrder from '../assets/filterIcons/mcorder.png';
import chik from '../assets/filterIcons/chikfila.png';
import crumbl from '../assets/filterIcons/crumbl.png';
import booBasket from '../assets/filterIcons/booBasket.png';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const metricItems = [
  { value: '2.9B', label: 'views' },
  { value: '215.5M', label: 'tries' },
  { value: '4.1M', label: 'posts' },
  { value: '172M', label: 'likes' },
  { value: '6.7M', label: 'shares' },
  { value: '41k', label: 'followers' },
];

const paidWork = [
  {
    id: 'paypal',
    title: 'PayPal',
    stat: '',
    image: mcOrder,
    href: 'https://www.tiktok.com/@paypal/video/7576809033022082317',
    embedSrc: 'https://www.tiktok.com/embed/7576809033022082317',
    eyebrow: '',
    description:
      'Built as paid client work with a strong emphasis on a clear interaction, quick audience payoff, and a format people would actually want to record with and share.',
  },
  {
    id: 'amazon',
    title: 'Amazon',
    stat: '',
    image: chik,
    href: 'https://www.tiktok.com/@amazoninfluencers/video/7524763298743454989',
    embedSrc: 'https://www.tiktok.com/embed/7524763298743454989',
    eyebrow: '',
    description:
      'A brand-facing AR concept where I worked across ideation and development, shaping the mechanic so it felt native to social video instead of just promotional.',
  },
  {
    id: 'shake-shack',
    title: 'Shake Shack',
    stat: '',
    image: prediction,
    href: 'https://www.tiktok.com/@rubywermfilters/photo/7437169421308792094',
    embedSrc: 'https://www.tiktok.com/embed/7437169421308792094',
    eyebrow: '',
    description:
      'Built as branded social AR work with a lightweight mechanic and a format designed to feel native to short-form content.',
  },
  {
    id: 'tinder',
    title: 'Tinder',
    stat: 'Part of the Year in Swipe campaign, nominated for a Webby',
    image: prediction,
    href: 'https://www.tiktok.com/@giannachristineclips/video/7542168335417478414',
    embedSrc: 'https://www.tiktok.com/embed/7542168335417478414',
    eyebrow: '',
    description:
      'Part of the Year in Swipe campaign, nominated for a Webby.',
  },
  {
    id: 'bww',
    title: 'Buffalo Wild Wings',
    stat: '',
    image: crumbl,
    href: 'https://www.tiktok.com/@buffalowildwings/video/7486554208074812702',
    embedSrc: 'https://www.tiktok.com/embed/7486554208074812702',
    eyebrow: '',
    description:
      'This work balanced branded storytelling with a simple, high-participation mechanic. My role covered both the creative direction of the idea and the effect implementation.',
  },
];

const embedItems = [
  {
    id: 'wild-meghan',
    title: 'Meghan Trainor',
    eyebrow: 'Creator post',
    image: prediction,
    href: 'https://www.tiktok.com/embed/7379367110406966571',
    embedSrc: 'https://www.tiktok.com/embed/7379367110406966571',
  },
  {
    id: 'wild-alex',
    title: 'Alex Warren',
    eyebrow: 'Creator post',
    image: booBasket,
    href: 'https://www.tiktok.com/embed/7378590190643744042',
    embedSrc: 'https://www.tiktok.com/embed/7378590190643744042',
  },
  {
    id: 'wild-joe',
    title: 'Joe Mele',
    eyebrow: 'Creator post',
    image: mcOrder,
    href: 'https://www.tiktok.com/embed/7378607033312054574',
    embedSrc: 'https://www.tiktok.com/embed/7378607033312054574',
  },
  {
    id: 'wild-brooke',
    title: 'Brooke Monk',
    eyebrow: 'Creator post',
    image: booBasket,
    href: 'https://www.tiktok.com/embed/7449878087845596446',
    embedSrc: 'https://www.tiktok.com/embed/7449878087845596446',
  },
  {
    id: 'wild-laufey',
    title: 'Laufey',
    eyebrow: 'Artist post',
    image: mcOrder,
    href: 'https://www.tiktok.com/@laufey/video/7441791200903826719',
    embedSrc: 'https://www.tiktok.com/embed/7441791200903826719',
  },
  {
    id: 'wild-olivia',
    title: 'Olivia Ponton',
    eyebrow: 'Creator post',
    image: chik,
    href: 'https://www.tiktok.com/@iamoliviaponton/video/7409415003893239071',
    embedSrc: 'https://www.tiktok.com/embed/7409415003893239071',
  },
  {
    id: 'wild-camila',
    title: 'Camila Loures',
    eyebrow: 'Creator post',
    image: prediction,
    href: 'https://www.tiktok.com/@camilaloures/video/7472478052929342726',
    embedSrc: 'https://www.tiktok.com/embed/7472478052929342726',
  },
  {
    id: 'wild-brooklyn-bailey',
    title: '@brooklynandbailey',
    eyebrow: 'Creator post',
    image: prediction,
    href: 'https://www.tiktok.com/@brooklynandbailey/video/7445776394660875563',
    embedSrc: 'https://www.tiktok.com/embed/7445776394660875563',
  },
  {
    id: 'wild-alissa',
    title: 'Alissa Violet',
    eyebrow: 'Creator post',
    image: chik,
    href: 'https://www.tiktok.com/@alissaviolet/video/7485422928448720159',
    embedSrc: 'https://www.tiktok.com/embed/7485422928448720159',
  },
  {
    id: 'wild-holly',
    title: 'Holly Madison',
    eyebrow: 'Creator post',
    image: prediction,
    href: 'https://www.tiktok.com/@hollyjeanmadison/video/7475188714713386270',
    embedSrc: 'https://www.tiktok.com/embed/7475188714713386270',
  },
  {
    id: 'wild-tinx',
    title: '@tinx',
    eyebrow: 'Creator post',
    image: booBasket,
    href: 'https://www.tiktok.com/@tinx/video/7409329115037469998',
    embedSrc: 'https://www.tiktok.com/embed/7409329115037469998',
  },
  {
    id: 'wild-bethany',
    title: '@bethanykajtar',
    eyebrow: 'Creator post',
    image: crumbl,
    href: 'https://www.tiktok.com/@bethanykajtar/video/7419009367447555361',
    embedSrc: 'https://www.tiktok.com/embed/7419009367447555361',
  },
];

function MetricCard({ item }) {
  return (
    <div className="filters-metric">
      <strong>{item.value}</strong>
      <span>{item.label}</span>
    </div>
  );
}

function FeaturedVideoCard({ item }) {
  const canPlay = Boolean(item.embedSrc);

  return (
    <article className="video-cell">
      <div className="video-frame">
        {canPlay ? (
          <div className="video-embed-wrap">
            <iframe
              src={item.embedSrc}
              title={item.title}
              className="video-embed"
              allow="encrypted-media"
              allowFullScreen
            />
          </div>
        ) : (
          <div className="video-poster-shell">
            <img className="video-static-image" src={item.image} alt={item.title} />
          </div>
        )}
      </div>
        <div className="video-cell-meta">
          <div className="video-cell-text">
            <h3>{item.title}</h3>
            {item.stat ? <span className="video-cell-stat">{item.stat}</span> : null}
          </div>
          <a className="underlined video-link" href={item.href} target="_blank" rel="noopener noreferrer">
            TikTok ↗
          </a>
        </div>
      </article>
  );
}

export function FiltersContent({ inline = false }) {
  return (
    <div className={`filters-page ${inline ? 'filters-page-inline' : ''}`}>
      {!inline ? (
        <div className="filters-topbar">
          <div className="filters-topbar-spacer" />
          <div className="social-links filters-social-links">
            <a
              href="https://www.tiktok.com/@rubywermfilters"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Ruby Werman TikTok filters"
            >
              <FontAwesomeIcon className="icon1" icon={faTiktok} size="1x" />
            </a>
          </div>
        </div>
      ) : null}

      <section className="filters-hero">
        <p className="filters-intro">
          I build TikTok effects for brands, artists, and my own audience.
        </p>
        <p className="filters-collaborators">
          My work combines concepting, interaction design, and development.
        </p>
      </section>

      <section className="filters-metrics" aria-label="Filter metrics">
        <div className="filters-metrics-label">Personal page stats</div>
        {metricItems.map((item) => (
          <MetricCard key={item.label} item={item} />
        ))}
      </section>

      <section className="filters-section">
        <div className="filters-section-heading filters-section-heading-wide">
          <div>
            <h2>Client work</h2>
            <p>Selected work samples.</p>
          </div>
        </div>
        <div className="video-gallery">
          {paidWork.map((item) => (
            <FeaturedVideoCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="filters-section">
        <div className="filters-section-heading filters-section-heading-wide">
          <div>
            <h2>Seen in the wild</h2>
          </div>
        </div>
        <div className="video-gallery video-gallery-secondary">
          {embedItems.map((item) => (
            <FeaturedVideoCard key={item.id} item={item} />
          ))}
        </div>
      </section>
    </div>
  );
}

function FiltersPage() {
  return (
    <div className="Home">
      <FiltersContent />
    </div>
  );
}

export default FiltersPage;
